import api from 'api'
import { z } from 'zod'

export const removeWorkerAssociationRequestSchema = z.object({
  agencyId: z.string(),
  associationId: z.number().int(),
})

export type RemoveWorkerAssociationRequest = z.infer<
  typeof removeWorkerAssociationRequestSchema
>

export const removeWorkerAssociation = async (
  request: RemoveWorkerAssociationRequest
): Promise<void> => {
  const parsedRequest = removeWorkerAssociationRequestSchema.parse(request)

  await api.post('/admin/dayforce/remove_worker_association', parsedRequest)
}
